// eslint-disable-next-line no-useless-escape
export const FLOWPAGE_SLUG_REGEX = /^[A-Za-z0-9\-\.\_]*$/

export const FILE_EXTENSION_REGEX = /\.[0-9a-z]+$/i
